import "#vendor/humps.js";

// The AssessmentViewer class MUST be defined before any sub-module
// (models/views/collections/scoring/_generated_templates) evaluates:
// sub-modules attach onto its static namespaces and read `Events` /
// `Templates` at eval time. Every file in this tree imports this one first.
window.AssessmentViewer = class AssessmentViewer {
  static Scoring = {};
  static Models = {};
  static Views = {};
  static Collections = {};
  // Templates are loaded from _generated_templates.js (generated by `rake assets:generate_inline_templates`)
  static Events = {
    Assessment: {
      completed: "assessment-completed",
    },
    AssessmentNavigation: {
      beginClicked: "assessmentNavigation-beginClicked",
      previousClicked: "assessmentNavigation-previousClicked",
      nextClicked: "assessmentNavigation-nextClicked",
      startOverClicked: "assessmentNavigation-startOverClicked",
      endClicked: "assessmentNavigation-endClicked",
    },
    Response: {
      selected: "response-selected",
    },
    SubmitterInfo: {
      changed: "submitterInfo-changed",
    },
  };

  constructor(el, attributes, options) {
    this.initialize = this.initialize.bind(this);
    this.submit = this.submit.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onEnd = this.onEnd.bind(this);
    this.on = this.on.bind(this);
    this.toJSON = this.toJSON.bind(this);
    this.getScore = this.getScore.bind(this);
    this.getResponses = this.getResponses.bind(this);
    this.attributes = attributes;
    this.options = jQuery.extend(
      {
        hideSubmitterInfo: false,
        submitOnComplete: true,
        data: null, // Additional data to send to the server on submit
      },
      options,
    );

    this.el = jQuery(el);
    this.attributes = humps.camelizeKeys(this.attributes);
    this.assessment = this.constructor.Models.Assessment.findOrCreate(this.attributes); // load from BackboneRelational cache
    this.initialize();
  }

  initialize() {
    this.assessment.set(this.attributes);
    const assessmentView = new this.constructor.Views.Assessment({
      model: this.assessment,
      hideSubmitterInfo: this.options.hideSubmitterInfo,
    }).render();
    this.el.html(assessmentView.el);

    // BEHAVIOUR
    assessmentView.$el.on(this.constructor.Events.AssessmentNavigation.startOverClicked, this.initialize);
    if (this.options.submitOnComplete) {
      return assessmentView.$el.on(this.constructor.Events.Assessment.completed, this.submit);
    }
  }

  // HELPER METHODS

  submit() {
    return jQuery.post(
      "/assessment_form_submissions",
      humps.decamelizeKeys({ assessmentFormSubmission: this.toJSON() }),
    );
  }

  onComplete(callback) {
    this.on(this.constructor.Events.Assessment.completed, () => callback(this.getScore(), this.getResponses()));
    return this;
  }

  onEnd(callback) {
    this.on(this.constructor.Events.AssessmentNavigation.endClicked, () =>
      callback(this.getScore(), this.getResponses()),
    );
    return this;
  }

  on(...args) {
    return this.el.on(...Array.from(args || []));
  }

  toJSON() {
    const payload = {
      assessmentId: this.assessment.id,
      hcmacid: this.assessment.get("hcmacid"),
      completionPageLink: this.assessment.completionPageLink(),
      results: {
        score: this.getScore(),
        responses: this.getResponses(),
      },
    };

    return jQuery.extend(payload, this.assessment.getSubmitterInfo(), this.options.data);
  }

  getScore() {
    return this.assessment.calculateScore();
  }

  getResponses() {
    return this.assessment.getQuestionsWithSelectedResponse().map((question) => ({
      question: question.get("title"),
      respondedWith: _.map(question.getSelectedResponses(), (response) => response.get("text")),
      explanation: question.getResponseExplanation(),
    }));
  }
};
